import { HTMLAttributes } from "react"

export default function SwiftUI(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48px"
      height="48px"
    >
      <radialGradient
        id="LYQUbLCUr5f7yOz~opfH_a"
        cx="23.941"
        cy="4.412"
        r="54.398"
        gradientTransform="matrix(1 0 0 .6044 0 1.745)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".202" stopColor="#27f5f1" />
        <stop offset=".29" stopColor="#25e2ee" />
        <stop offset=".468" stopColor="#20b1e7" />
        <stop offset=".717" stopColor="#1963db" />
        <stop offset=".857" stopColor="#1434d4" />
        <stop offset="1" stopColor="#0015b5" />
      </radialGradient>
      <path
        fill="url(#LYQUbLCUr5f7yOz~opfH_a)"
        d="M34.249,42H13.751C9.47,42,6,38.53,6,34.249v-10.78L21,6h13.248C38.53,6,42,9.47,42,13.751 v20.497C42,38.53,38.53,42,34.249,42z"
      />
      <path
        fill="#1a5cf9"
        d="M21,6L6,23.469c4.325,5.751,14.813,9.78,21.688,3.468c4-5,1.688-13.188-1.313-15.875 C24.868,9.712,23.064,7.77,21,6z"
      />
      <path
        fill="#21aaf5"
        d="M21,6L6,21.683v1.786c5.079,3.953,13.005,5.51,18.563,0.406c4-5,1.688-13.188-1.313-15.875 C22.613,7.43,21.848,6.735,21,6z"
      />
      <path
        fill="#25e0f2"
        d="M6,18.477v3.206c4.686,1.975,10.315,1.966,14.563-1.933C23.787,15.72,23.033,9.622,21,6h-3.15 L6,18.477z"
      />
      <path
        fill="#18ffff"
        d="M13.751,6C9.47,6,6,9.47,6,13.751v4.726c3.476,0.382,7.055-0.459,9.979-3.144 c2.119-2.649,2.46-6.188,1.871-9.333H13.751z"
      />
      <path d="M12.608,14.87c0,0,6.833,10.327,12.578,13.82c-2.174,0.699-6.894,3.555-15.124-1.492c2.096,2.873,5.807,8.635,14.891,8.092 c3.183-0.155,5.124-1.165,6.91-1.863c1.786-0.698,3.494-0.621,4.969,2.019c0.311-2.407,0.388-4.659-2.096-7.221 c0,0,2.456-9.363-8.001-16.751c2.174,4.348,3.433,6.8,2.411,12.791c-2.329-1.553-10.931-8.48-12.872-10.732 c1.398,2.485,5.419,7.936,6.816,9.334C20.606,21.159,12.608,14.87,12.608,14.87z" />
    </svg>
  )
}
